export const getListStyle = (isDraggingOver, grid = 8) => ({
  // width: "100%",
});
